module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a3ec03e8d784da668d0957acc88b3833.png";